var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar",
      style: _vm.sidebarStyle,
      attrs: {
        "data-color": _vm.backgroundColor,
        "data-image": _vm.backgroundImage,
        "data-active-color": _vm.activeColor
      }
    },
    [
      _c(
        "div",
        { ref: "sidebarScrollArea", staticClass: "sidebar-wrapper" },
        [
          _c("div", { staticClass: "logo" }, [
            _c("a", { staticClass: "logo-mini", attrs: { href: "#/" } }, [
              _c(
                "div",
                { staticClass: "logo-img" },
                [_c("font-awesome-icon", { attrs: { icon: "save" } })],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              { staticClass: "simple-text logo-normal", attrs: { href: "" } },
              [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
            )
          ]),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._t(
                "links",
                _vm._l(_vm.sidebarLinks, function(link, index) {
                  return _c(
                    "sidebar-item",
                    { key: link.name + index, attrs: { link: link } },
                    _vm._l(link.children, function(subLink, index) {
                      return _c("sidebar-item", {
                        key: subLink.name + index,
                        attrs: { link: subLink }
                      })
                    })
                  )
                })
              )
            ],
            2
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44abce88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44abce88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarPlugin/SideBar.vue
// module id = Dd6b
// module chunks = 4